'use client'

import { ReactNode, createContext, useContext, useState } from 'react'

const DialogPortalContainerContext = createContext<HTMLElement | null>(null)

export function useDialogPortalContainer() {
  return useContext(DialogPortalContainerContext)
}

export type DialogPortalContextProps = {
  children?: ReactNode
}

export function DialogPortalContext({ children }: DialogPortalContextProps) {
  const [dialogPortalContainer, setDialogPortalContainer] = useState<HTMLElement | null>(null)
  return (
    <DialogPortalContainerContext.Provider value={dialogPortalContainer}>
      {children}
      <aside ref={setDialogPortalContainer} className="absolute z-30" />
    </DialogPortalContainerContext.Provider>
  )
}
